import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logError } from "@/lib/logger";

/** Encapsulates scenario feed fetching + voting so Feed.jsx only handles rendering. */
export function useScenarios(category) {
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/scenarios", { params: category ? { category } : {} });
      setScenarios(data);
    } catch (e) {
      logError(e);
    }
    setLoading(false);
  }, [category]);

  useEffect(() => {
    load();
  }, [load]);

  const vote = async (scenarioId, voteValue) => {
    try {
      const { data } = await api.post(`/scenarios/${scenarioId}/vote`, { vote: voteValue });
      setScenarios((prev) => prev.map((s) => (s.id === scenarioId ? data : s)));
    } catch (e) {
      logError(e);
    }
  };

  return { scenarios, loading, vote };
}
